import dayjs, { Dayjs } from 'dayjs';

export const timeToSeconds = (timeObj: Dayjs): number => {
  const timeStr = dayjs(timeObj).format('HH:mm:ss');
  const [hours, minutes, seconds] = timeStr.split(':').map(Number);
  return hours * 3600 + minutes * 60 + seconds;
};
